<template>
  <div class="w-screen h-screen lg:p-10 bg-pure-white overflow-hidden">
    <div class="bl-auth-background px-4 lg:p-0">
      <div class="bl-auth-card rounded-3xl bg-pure-white p-6 lg:p-14">
        <form v-if="!sent" @submit.prevent="verifyEmail">
          <div class="space-y-3 mb-6 lg:w-160">
            <BlTextTitle4 text="Forgot your password?" />
            <BlTextBody2
              text="Before you can update your password, we need to verify your identity. Please provide your email address below, and we'll send you a link to reset your password."
            />
          </div>

          <BlInputText
            class="mb-4 lg:w-160"
            :input="emailInput"
            @changed="inputHandler"
          />

          <div class="flex items-center justify-end gap-4">
            <BlInputButton type="plain" label="Cancel" @clicked="goSignin" />
            <BlInputButton
              :disabled="!emailInput.model"
              buttonType="submit"
              label="Verify"
              :loading="loading"
            />
          </div>
        </form>
        <form v-else @submit.prevent="goSignin">
          <div class="space-y-3 mb-6 w-160">
            <BlTextTitle4 text="Check your email" />
            <BlTextBody2
              text="We've sent you an email with a link to reset your password. Simply click on the link in the email to continue the password reset process."
            />
          </div>

          <div class="flex items-center justify-end gap-4">
            <BlInputButton buttonType="submit" label="Got it" />
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import BlTextBody2 from "../BlTextBody2.vue";
import BlInputText from "../BlInputText.vue";
import BlInputButton from "../BlInputButton.vue";
import BlTextTitle4 from "../BlTextTitle4.vue";

export default {
  name: "ForgotPassword",
  components: { BlTextBody2, BlInputText, BlInputButton, BlTextTitle4 },
  data() {
    return {
      loading: false,
      emailInput: {
        placeholder: "Type your email here",
        label: "Email address",
        inputType: "email",
        model: "",
        error: ""
      },
      sent: false
    };
  },
  methods: {
    ...mapActions(["showToast"]),
    inputHandler(payload) {
      payload.input.model = payload.value;
      payload.input.error = "";
    },
    verifyEmail() {
      this.loading = true;
      const email = this.emailInput.model;
      this.$http.plain
        .post("/password_resets", { email })
        .then(response => this.tokenSent(response))
        .catch(error => this.emailNotFound(error))
        .finally(() => {
          this.loading = false;
        });
    },
    tokenSent({ status }) {
      if (status !== 200) return;
      this.sent = true;
      const title =
        "The password reset link has been successfully sent via email";
      this.showToast({ title, message: "", type: "success" });
    },
    emailNotFound(error) {
      const err = error.response && error.response.data;
      const message = err || "Email not found";
      this.showToast({ title: "", message, type: "error" });
      this.emailInput.error = `Sorry, we couldn't find an account associated with the email address you entered. Please double-check your email or contact your admin to continue.`;
    },
    goSignin() {
      return this.$router.push({ name: "Signin" });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/auth/ForgotPassword.vue